import TranslationUtils from '@gik/core/utils/TranslationUtils';
import { StartInkindCardBlockName } from '../';

const translations = {
  title: 'Ease someone&apos;s life a little.',
};

export default {
  [StartInkindCardBlockName]: translations,
};

export const translationKeys: typeof translations = TranslationUtils.mapKeys(StartInkindCardBlockName, translations);
